/**
 * The workspace backdrop.
 *
 * Static on purpose: the showcase template moved it with the pointer, which is
 * charming for thirty seconds and distracting for eight hours. The gradient
 * itself lives in `index.css` (`.wallpaper`) so re-skinning is a palette edit.
 */
export function Wallpaper() {
  return (
    <div className="pointer-events-none fixed inset-0 overflow-hidden">
      <div className="wallpaper absolute inset-0" />
    </div>
  );
}
